import * as React from 'react';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import clsx from 'clsx';

import AppointmentForm from '../../organisms/Forms/AppointmentForm';
import {
  useMediaQueryBreakPoint,
  IS_PHONE_OR_TABLET,
  useFirstAvailability,
} from '../../../src/hooks';
import NoClientNoAvailability from '../../organisms/ProfileContent/NoClientNoAvailability';

const HcdRDVPartners = () => {
  const card = useSelector(state => get(state, 'cards.item'));
  const firstFreeTimeslot = useFirstAvailability(card, 'ALL');
  const isPhoneOrTablet = useMediaQueryBreakPoint(IS_PHONE_OR_TABLET);

  if (!card) return <div />;

  if (!firstFreeTimeslot)
    return (
      <NoClientNoAvailability card={card} isLoadingAvailabilities={false} />
    );

  return (
    <div
      id="rdv"
      className={clsx(
        'page profile-content__rdv',
        isPhoneOrTablet && 'profile-content__rdv--mobile',
      )}
    >
      <AppointmentForm card={card} />
    </div>
  );
};

export default HcdRDVPartners;
